import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ListNumberedPronounced = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.6" d="M10.5 4L15.5 4" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M10.5 8H14.5" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M11.5 12H15.5" stroke={color} strokeLinecap="round" />
        <path
          d="M6.03202 12C5.71767 12 5.44777 11.8885 5.22232 11.6655C5.00005 11.4392 4.88892 11.1684 4.88892 10.853C4.88892 10.5408 5.00005 10.2731 5.22232 10.0501C5.44777 9.82709 5.71767 9.71558 6.03202 9.71558C6.33685 9.71558 6.60358 9.82709 6.8322 10.0501C7.06082 10.2731 7.17513 10.5408 7.17513 10.853C7.17513 11.0633 7.12115 11.256 7.01319 11.4313C6.90841 11.6033 6.77028 11.7419 6.59882 11.8471C6.42735 11.949 6.23842 12 6.03202 12Z"
          fill={color}
        />
        <path d="M3.5144 4V11.9014H1.84948V5.80444H1.80334L0 6.94221V5.23846L1.94945 4H3.5144Z" fill={color} />
      </svg>
    )
  },
)

export default ListNumberedPronounced
